import React from "react"
import { useLocation } from "react-router-dom"
import { reportErrorMessage } from "utils/ErrorReporting"
import { UnknownErrorOccurred } from "../../views/error/UnknownErrorOccurred"

const ServicesLogoutContainer = () => {
  const urlSearchParams = new URLSearchParams(useLocation().search)
  const kind = "kind"
  const message = "message"
  const returnTo = "return_to"
  const referrer = document.referrer

  const urlReferrer = new URL(referrer)
  const urlSearchReturnToParam = new URLSearchParams(urlReferrer.search)
  const returnToUrl = urlSearchReturnToParam.get(returnTo)

  const redirectKind = urlSearchParams.get(kind)
  const redirectMessage = urlSearchParams.get(message)

  // Delete this after testing on stage
  console.log(returnToUrl)

  const errorMessage = `User coming from ${referrer} could not be authenticated in Zendesk Guide.
  Reply received of kind: '${redirectKind}'.
  Error message: '${redirectMessage}'.
  Check Runbook for possible root causes and corrective measures.`

  reportErrorMessage(errorMessage)
  return <UnknownErrorOccurred returnToLink={returnToUrl} />
}

export { ServicesLogoutContainer }
